import React, { Component } from 'react';

// componentes de bootstrap
import { Button, Modal } from 'react-bootstrap';
import imagen_vehiculo from '../../assets/images/vehiculo.png';

class PedidosPendientes extends Component {
    renderFilasPedido = (pedido, pedidoIndex) => {
        const observaciones = Array.isArray(pedido?.observaciones) ? pedido.observaciones : [];
        const rowSpan = Math.max(Number(pedido?.rowspan) || 0, observaciones.length || 1);
        const isChecked = !!pedido?.checked;

        const checkboxCell = (
            <td rowSpan={rowSpan} style={{ textAlign: 'center' }}>
                <input
                    type="checkbox"
                    aria-label={`Seleccionar pedido ${pedido?.q1nropdc ?? ''}`}
                    checked={isChecked}
                    disabled={isChecked}
                    onChange={(event) =>
                        this.props.actualizarPedidoPendiente(
                            event,
                            pedido?.q1codcia,
                            pedido?.q1codsuc,
                            pedido?.q1nropte,
                            pedido?.q1nropdc
                        )
                    }
                />
            </td>
        );

        if (observaciones.length === 0) {
            return (
                <tr key={`pedido-${pedido?.q1nropdc ?? pedidoIndex}`} id={`${pedido?.q1nropdc ?? 'pedido'}-${pedidoIndex}`}>
                    <td rowSpan={rowSpan}>{pedido?.q1codsuc}</td>
                    <td rowSpan={rowSpan}>{pedido?.q1nropte}</td>
                    <td rowSpan={rowSpan}>{pedido?.q1mjdt}</td>
                    <td rowSpan={rowSpan} style={{ fontSize: '14px' }}>
                        {pedido?.q1codcli} {pedido?.q1razsoc}
                    </td>
                    <td rowSpan={rowSpan}>
                        {pedido?.q1nrfser} {pedido?.q1nrfcor}
                    </td>
                    <td rowSpan={rowSpan}>{pedido?.eudscabr}</td>
                    <td style={{ fontSize: '12px' }}>&nbsp;</td>
                    <td style={{ fontSize: '12px' }}>&nbsp;</td>
                    {checkboxCell}
                </tr>
            );
        }

        return observaciones.map((obs, detalleIndex) => (
            <tr
                key={`pedido-${pedido?.q1nropdc ?? pedidoIndex}-obs-${detalleIndex}`}
                id={`${pedido?.q1nropdc ?? 'pedido'}-${pedidoIndex}-${detalleIndex}`}
            >
                {detalleIndex === 0 && (
                    <>
                        <td rowSpan={rowSpan}>{pedido?.q1codsuc}</td>
                        <td rowSpan={rowSpan}>{pedido?.q1nropte}</td>
                        <td rowSpan={rowSpan}>{pedido?.q1mjdt}</td>
                        <td rowSpan={rowSpan} style={{ fontSize: '14px' }}>
                            {pedido?.q1codcli} {pedido?.q1razsoc}
                        </td>
                        <td rowSpan={rowSpan}>
                            {pedido?.q1nrfser} {pedido?.q1nrfcor}
                        </td>
                        <td rowSpan={rowSpan}>{pedido?.eudscabr}</td>
                    </>
                )}
                <td style={{ fontSize: '12px' }}>{obs?.articulo}</td>
                <td style={{ fontSize: '12px' }}>{obs?.observacion}</td>
                {detalleIndex === 0 && checkboxCell}
            </tr>
        ));
    };

    render() {
        const data = this.props.data ?? {};
        const pedidos = data?.pedidos_pendientes ?? [];
        const mostrarModal = !!data?.modal_pedidos_pendientes?.mostrar_modal;

        if (!pedidos.length) return null;

        const color = 'warning';
        const titulo = 'Listado de Pedidos Pendientes';

        return (
            <Modal
                show={mostrarModal}
                onHide={() => this.props.mostrarModalPedidosPendientes(null)}
                backdrop="static"
                keyboard={false}
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{titulo}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="card card-widget widget-user-2">
                        <div className={`widget-user-header bg-${color}`}>
                            <div className="widget-user-image">
                                <img className="img-circle elevation-2" src={imagen_vehiculo} alt="Vehículo" />
                            </div>
                            <h3 className="widget-user-username">
                                <b>Pedidos pendientes</b>
                            </h3>
                        </div>

                        <div className="card-footer p-0">
                            <div className="pedidos-table-wrapper">
                                <table className="table table-head-fixed table-sm pedidos-table">
                                    <thead>
                                        <tr>
                                            <th width="5%">SUC</th>
                                            <th width="8%">PT.SALIDA</th>
                                            <th width="7%">FECHA</th>
                                            <th width="20%">CLIENTE</th>
                                            <th width="10%">DOC. PAGO</th>
                                            <th width="10%">ESTADO</th>
                                            <th width="15%">ARTICULO</th>
                                            <th width="20%">OBSERVACION</th>
                                            <th width="5%">ACCIÓN</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pedidos.flatMap((pedido, index) => this.renderFilasPedido(pedido, index))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.mostrarModalPedidosPendientes(null)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default PedidosPendientes;